var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"AUserProfilePic"},[(_vm.isOnline)?_c('a-image',{staticClass:"image user-profile-image",attrs:{"image-path":_vm.profilePicUrl(),"size":_vm.imageSize || '100x100'}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }